import { useQueries, UseQueryResult } from '@tanstack/react-query';

import { getDetailsOptions } from '@api/configurationComparison';

import { fieldsOptionsFormatted } from '@utils/formatter';

import { IMoTreeFilters } from '@interfaces/cmModule/cmModule';
import { TMoNamesWithComparisonId } from '@interfaces/cmModule/dto/cmModuleDTO';

import { MO_DETAILS_OPTIONS } from '@constants/queryKeys';

interface IUseQueriesOptionsDetailsTableReturnType {
	isInitialDetailsOptionsLoading: boolean;
	detailsOptions: IMoTreeFilters[];
}

export const useQueriesOptionsDetailsTable = (
	params: TMoNamesWithComparisonId,
): IUseQueriesOptionsDetailsTableReturnType => {
	const { moNames, comparisonId } = params;

	const detailsOptions = useQueries({
		queries: moNames.map((moName) => ({
			queryKey: [MO_DETAILS_OPTIONS, moName, comparisonId],
			queryFn: () => getDetailsOptions({ moName, comparisonId }),
			enabled: !!moName.length,
			staleTime: Infinity,
		})),
	});

	return {
		isInitialDetailsOptionsLoading:
			detailsOptions.some((result: UseQueryResult<string[]>) => result.isInitialLoading),
		detailsOptions: detailsOptions.map((result: UseQueryResult<string[]>, index) => ({
			moName: moNames[index],
			data: fieldsOptionsFormatted(result.data || [])
				.map((option) => ({
					...option,
					name: moNames[index],
				})),
		})),
	};
};
